export default __webpack_public_path__ + "static/media/phoneidle.f831a2c1.png";